import { FetchRequestHandler, RequestHandler, RequestInformation } from '@teqplay/api'

function headersToObject(headers: Headers) {
  const out: Record<string, string> = {}
  headers.forEach((v, k) => {
    out[k] = v
  })
  return out
}

export class LoggerRequestHandler<TContext> implements RequestHandler<TContext> {
  async handleRequest(req: RequestInformation<TContext>): Promise<Response> {
    const url = req.buildURL() // includes baseURL + path + query params
    const init = req.buildRequestInit() // includes method + final headers + options

    // Log to the server console (Next.js logs appear in the terminal where the server runs) only in dev
    if (process.env.NODE_ENV !== 'production') {
      console.log('[API Request]', {
        method: init.method,
        url: url.toString(),
        headers: headersToObject(init.headers as Headers)
      })
    }

    // Delegate to the default fetch-based handler
    return new FetchRequestHandler<TContext>().handleRequest(req)
  }
}
